export enum ETemplateType {
  DEFAULT = 'DEFAULT',
  AUTHENTIQUE = 'AUTHENTIQUE',
  EBAY = 'EBAY',
  VERA_ADMIN = 'VERA_ADMIN',
  VERA_OPERATOR = 'VERA_OPERATOR',
}
